import React from 'react';
import {connect} from 'react-redux'
import {parsePhoneNumberFromString} from 'libphonenumber-js';
import moment from "moment-timezone";

class ForwardHistory extends React.Component {

    render() {
        let history = [];
        const timezone = this.props.business.call_at_timezone;
        this.props.forward_history.map(function (value, index) {
            let jsx;
            if (value.type === "SMS" && value.recipient && parsePhoneNumberFromString(value.recipient, "US")) {
                jsx = <h6 key={index}
                          className="history-p pb-1 pt-1 pl-0 pr-2 mb-2 d-sm-flex d-block align-items-center w-100">
                    <span>{(value.user && (value.user.firstname ?? "")) + " " + (value.user && (value.user.lastname ?? ""))} {__('forwarded to')}: {(value.recipient_nickname ? value.recipient_nickname + " - " : null)} {parsePhoneNumberFromString(value.recipient, "US").format("NATIONAL")} via {value.type}  </span><span
                    className="d-block d-sm-inline">{moment.tz(value.created_at, timezone).format("M/D/YYYY, h:mm A z")}</span>
                </h6>
                history.push(jsx)
            } else if (value.type === "email") {
                jsx = <h6 key={index}
                          className="history-p pb-1 pt-1 pl-0 pr-2 mb-2 d-sm-flex d-block align-items-center w-100">
                    <span>{(value.user && (value.user.firstname ?? "")) + " " + (value.user && (value.user.lastname ?? ""))} {__('forwarded to')}: {(value.recipient_nickname ? value.recipient_nickname + " - " : null)} {value.recipient} via {value.type}  </span><span
                    className="d-block d-sm-inline">{moment.tz(value.created_at, timezone).format("M/D/YYYY, h:mm A z")}</span>
                </h6>
                history.push(jsx)
            }
        });

        if (history.length > 0) {
            return (
                <div>
                    <h6 className='mb-0'>
                        {__("Forward History")}:&nbsp;
                    </h6>
                    {history}
                </div>
            );
        } else {
            return null;
        }

    }
}

function mapStateToProps(state) {
    return {
        forward_history: state.feedback_detail ? state.feedback_detail.forward_history : [],
        business: state.business,
    }
}

export default connect(mapStateToProps)(ForwardHistory);
